import React, { useEffect, useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";
import Cookies from "universal-cookie";
import InfoCapacidadInstalada from "../../Funciones/InfoCapacidadInstalada";

function CreaCapacidad() {
  const cookies = new Cookies();
  const [postFechaCorte, setPostFechaCorte] = useState([]);

  const [sede, setSede] = useState([]);
  const [list, setList] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerSedesPorInstitucionId?InstitucionId=" +
        cookies.get("institucionid"),
    })
      .then((Response) => {
        setList(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList]);

  const [archivos, setArchivos] = useState(null);
  const subirArchivos = (e) => {
    setArchivos(e);
  };
  const insertarArchivos = async () => {
    const f = new FormData();
    for (let index = 0; index < archivos.length; index++) {
      f.append("files", archivos[index]);
    }
    await axios
      .post(
        "https://suadesarrollo.azurewebsites.net/api/CargaMasivosCapacidadInstalada?InstitucionId=" +
          cookies.get("institucionid") +
          "&FechaCorte=" +
          postFechaCorte,
        f,
      )

      .then((response) => {
        console.log(response.data);

        alert("Cargado");
        window.location.reload("/");
      })
      .catch((error) => {
        console.log(error);
        alert(error);
      });
  };
  return (
    <div>
      <div className="container">
        <div className="text-center">
          <div class="container-fluid">
            <div class="card shadow mb-4">
              <div class="card-header py-3">
                <h6 class="m-0 font-weight-bold text-primary">
                  Sube el documento
                </h6>
              </div>
              <br></br>
              <a href="../../formatos/FormatoCapacidadInstalada.csv" download>
                Descargar Formato
              </a>
              <div class="card-body">
                <div class="table-responsive">
                  <table
                    class="table table-bordered"
                    id="dataTable"
                    width="100%"
                    cellspacing="0"
                    border={1}
                  >
                    <td>
                      {" "}
                      <input
                        type="file"
                        name="files"
                        accept=".csv"
                        multiple
                        onChange={(e) => subirArchivos(e.target.files)}
                      />
                    </td>

                    <td>
                      {" "}
                      <input
                        type="number"
                        className="form-control form-control-user"
                        placeholder="Año de corte ejemplo: 2024"
                        onChange={(e) => setPostFechaCorte(e.target.value)}
                      />{" "}
                    </td>
                  </table>

                  <hr />
                  <button
                    className="btn btn-primary"
                    onClick={() => insertarArchivos()}
                  >
                    insertar archivos
                  </button>
                </div>
              </div>
            </div>
          </div>
          <InfoCapacidadInstalada />
        </div>
      </div>
    </div>
  );
}
export default CreaCapacidad;
